import type { SrmPurchaseRequestTypeTreeVo } from "@/types/apis";

/**
 * 根据value获取对应的label
 * @param treeData 树形数据
 * @param value 要查找的值
 * @returns 对应的label，如果未找到则返回undefined
 */
export function getLabelByValue(
  treeData: SrmPurchaseRequestTypeTreeVo[],
  value: string,
): string | undefined {
  for (const item of treeData) {
    if (item.value === value) {
      return item.desc;
    }

    if (item.children && item.children.length > 0) {
      const result = getLabelByValue(item.children, value);
      if (result) {
        return result;
      }
    }
  }

  return void 0;
}
